
import  { useState } from "react";
import classNames from "classnames";

import { PillInputBox } from "../../components/forms/form-inputs";
import { AppSwitch } from "../../components/utilities/switcher";
import { faEye, faEyeSlash } from "@fortawesome/free-regular-svg-icons";
import { LoadingIndicator } from "../../components/utilities/loader";
import { AppAlert } from "../../components/utilities/app-alert";
import { useAuth } from "../../services/authentication/authentication.context";

import "../../styles/home.css";
import { AppHeader } from "../../components/header/header";
import { LargeTextBox } from "../../components/forms/textarea";
import { AppFooter } from "../../components/footer/footer";

export const ContactUs = () => {
     
    const [email, setEmail] = useState('');
    const [message, setMessage] = useState('');
    const [onAlert, setOnAlert] = useState();
  
    const { isLoading } = useAuth();
  
    const handleSubmit = async(e) => {
          e.preventDefault();
          setOnAlert({
            caption: "Alert",
            message: "This feature is still under development",
            accept: "Ok",
            action: () => setOnAlert()
          })
    }
  
    return (
        <div>
            <AppHeader />
            <div className={classNames("full-v","flx-cnt-pg")}>
                
                {isLoading && <LoadingIndicator />}
                {onAlert &&
                <AppAlert 
                    caption={onAlert.caption}
                    message={onAlert.message}
                    accept={onAlert.accept}
                    onAccept={onAlert.action}
                    closeAlert={() => setOnAlert()}
                />
                }
                <div className={classNames("cap","lg-txt")}>Send us a message</div>
                <div className="sm-sp" />
                <form className="sign-in" onSubmit={handleSubmit}>
                    <PillInputBox
                        type={"email"}
                        name={"email"}
                        caption={"Email"}
                        placeholder={"e.g mymail@provider.com"}
                        onChange={(e) => setEmail(e.target.value)}
                    />

                    <PillInputBox
                        type={"text"}
                        name={"names"}
                        caption={"Names"}
                        placeholder={"Type your names"}
                        onChange={(e) => setEmail(e.target.value)}
                    />
                    
                   <LargeTextBox
                        placeholder={"Type your message here"}
                        name={'message'}
                        onChange={(e) => setMessage(e.target.value)}
                   />
                    
                    <button 
                        className={classNames("form-button",'pill-input-box')}
                    >
                        Submit
                    </button>
                   
                </form>
            </div>
            <AppFooter />
        </div>
    )
}